import { Prisma } from "@prisma/client";

export const businessSectorSelectValues = Prisma.validator<Prisma.BusinessSectorDefaultArgs>()({
  select: {
    id: true,
    name: true,
    parentId: true,
    createdAt: true,
    updatedAt: true,
  },
});

export type BusinessSectorType = Prisma.BusinessSectorGetPayload<typeof businessSectorSelectValues>;

export const businessSectorWithParentSelectValues =
  Prisma.validator<Prisma.BusinessSectorDefaultArgs>()({
    select: {
      ...businessSectorSelectValues.select,
      parent: {
        select: {
          id: true,
          name: true,
        },
      },
    },
  });

export type BusinessSectorWithParentType = Prisma.BusinessSectorGetPayload<
  typeof businessSectorWithParentSelectValues
>;

export const businessSectorWithChildrenSelectValues =
  Prisma.validator<Prisma.BusinessSectorDefaultArgs>()({
    select: {
      ...businessSectorSelectValues.select,
      parent: {
        select: {
          id: true,
          name: true,
        },
      },
      children: {
        select: {
          id: true,
          name: true,
        },
      },
    },
  });

export type BusinessSectorWithChildrenType = Prisma.BusinessSectorGetPayload<
  typeof businessSectorWithChildrenSelectValues
>;

export const businessSectorWithParentAndCountSelectValues =
  Prisma.validator<Prisma.BusinessSectorDefaultArgs>()({
    select: {
      ...businessSectorSelectValues.select,
      parent: {
        select: {
          id: true,
          name: true,
        },
      },
      _count: {
        select: {
          children: true,
        },
      },
    },
  });

export type BusinessSectorWithParentAndCountType = Prisma.BusinessSectorGetPayload<
  typeof businessSectorWithParentAndCountSelectValues
>;

export interface UpsertBusinessSectorDto {
  name: string;
}

export interface MergeBusinessSectorDto {
  childIds: string[];
  parentName: string;
}
